export default "__VITE_ASSET__6ja0mbCy__"